import React,{useEffect,useState}from "react";
import { Button, Table, Card, Form, Input, Row, Col, DatePicker, Select } from "antd";
import { ProfileTwoTone } from "@ant-design/icons";
import { useModel } from "../../../models";
import ListComponents from "../components/ListComponents";
import SupplierBillService from "./SupplierBillService.js"
import {decoder} from "../../../utils/decoder"
const { Option } = Select;
const { RangePicker } = DatePicker;


const TableHeader = () => {
    const [{ tabsKey,tabsList,selectedSupplierBill}, { setTabParams, SupplierRechargeList, SupplierResizeLimitList, SupplierTransferAccountsList}] = useModel("supplierBill")

    // const [{ TabType }, { setTabParams }] = useModel("supplierBill")
    const [{ accountTypeDict }, { getAccountTypeDict }] = useModel("cmDict");

    const [form] = Form.useForm();
    useEffect(()=>{
        form.resetFields();
        getAccountTypeDict()
        // console.log(accountTyprDict)
    },[])
    const tabList = {
        "recharge": SupplierRechargeList,
        "resizeLimit": SupplierResizeLimitList,
        "transferAccounts": SupplierTransferAccountsList,
    }
    const tabTime = {
        "recharge": "充值日期",
        "resizeLimit": "调额日期",
        "transferAccounts": "转账日期",
    }
    const Title = () => {
        return (
            <h3 style={{ flex: "1" }}>
                <ProfileTwoTone />
                {/* <span className="margin-left-8">供应商账单详情-</span>
                <span className="margin-left-16">供应商名称</span> */}
            </h3>
        )
    }
    const onFinish = () => {
        // let data = form.getFieldsValue()
        // setTabParams(data)
        let {time,...datas} = form.getFieldsValue()     
        let startTime =time&&time.length!=0? time[0].format("YYYY-MM-DDT00:00:00"):""
        let endTime = time&&time.length!=0? time[1].format("YYYY-MM-DDT23:59:59"):""
        let data = {
            ...datas,
            startTime,
            endTime,
            pageNum:1,
            pageSize:15,
            relationId:selectedSupplierBill.id
        }
        tabList[tabsKey]({data})
        // console.log(data)
    }
    const onChangeVal = () => {

    }
    const reset = () => {
        setTabParams({});
        form.resetFields();
        let data = {
            pageNum:1,
            pageSize:15,
            relationId:selectedSupplierBill.id
        }
        tabList[tabsKey]({data})
    }
    return (
        <Card
            title={<Title />}
        >
            <Form
                name="recharge"
                form={form}
                labelCol={{ span: 8 }}
                onFinish={onFinish}
                onValuesChange={onChangeVal}
            >
                <Row>
                    {/* <Col span={4}>
                        <Form.Item
                            name="accountCode"
                            label="账户编号"
                        >
                            <Input placeholder="账户编号" />
                        </Form.Item>
                    </Col> */}
                    <Col span={4}>
                        <Form.Item
                            name={tabsKey!="transferAccounts"?"accountType":"transferOutType"}
                            label={tabsKey!="transferAccounts"?"账户类型":"转出账户类型"}
                        >
                            <Select placeholder="账户类型" options={accountTypeDict}>
                                {/* {accountTyprDict.map((item) => {
                                    
                                    // return (<Option key={item.type} value={item.type}>{item.type}</Option>)
                                })} */}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="time"
                            label={tabTime[tabsKey]}
                        >
                            <RangePicker />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item>
                            <Button style={{ marginLeft: "20px" }} type="primary" htmlType="submit">查询</Button>
                            <Button style={{ marginLeft: "20px" }} onClick={reset}>重置</Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    )
}
export default function (props) {
    // const [isShow,setIsShow] = useState(false)
    const [{ accountTypeDict,payTypeDict}, { getAccountTypeDict,getPayTypeDict }] = useModel("cmDict");
    const [{ tabsKey,tabsList,tabParams,tabPage,selectedSupplierBill}, { SupplierRechargeList, SupplierResizeLimitList, SupplierTransferAccountsList }] = useModel("supplierBill")
    useEffect(()=>{
        getAccountTypeDict()
        getPayTypeDict()
    },[])
//充值表头
const columns = [
    {
        title: '账户编号',
        dataIndex: 'accountCode',
        render: text => <span>{text}</span>,
    },
    {
        title: '账户类型',
        dataIndex: 'accountType',
        align: 'left',
        render: text => <span>{decoder(accountTypeDict,text)}</span>,
    },
    {
        title: "原剩余金额",
        dataIndex: 'remainingAmount',
    },
    {
        title: '充值金额',
        dataIndex: 'rechargeAmount',
    },
    {
        title: '支付方式',
        dataIndex: 'paymentMethod',
        render: text => <span>{decoder(payTypeDict,text)}</span>,
    },    
    {
        title: "业务员",
        dataIndex: 'createUser',
    },
    {
        title: "充值日期",
        dataIndex: 'createTime',
    },
    {
        title: "备注",
        dataIndex: 'remarks',
    },
];
//调额表头
const resizeLimitHeader = [
    {
        title: '账户编号',
        dataIndex: 'accountCode',
        render: text => <span>{text}</span>,
    },
    {
        title: '账户类型',
        dataIndex: 'accountType',
        align: 'left',
        render: text => <span>{decoder(accountTypeDict,text)}</span>,
    },
    {
        title: "授信额度",
        dataIndex: 'creditLine',
    },
    {
        title: '调整额度',
        dataIndex: 'adjustmentLimit',
    },
    {
        title: "业务员",
        dataIndex: 'createUser',
    },
    {
        title: "调额日期",
        dataIndex: 'createTime',
    },
    {
        title: "备注",
        dataIndex: 'remarks',
    },
]
//转账表头
const transferAccountsHeader = [
    {
        title: '转账金额',
        dataIndex: 'transferAmount',
        align: 'left',
    },
    {
        title: "转入账户",
        dataIndex: 'transferToType',
        render: text => <span>{decoder(accountTypeDict,text)}</span>,
    },
    {
        title: '转入前金额',
        dataIndex: 'beforeTransferIn',
    },
    {
        title: '转入后金额',
        dataIndex: 'afterTransferIn',
    },
    {
        title: "转出账户",
        dataIndex: 'transferOutType',
        render: text => <span>{decoder(accountTypeDict,text)}</span>,
    },
    {
        title: "转出前金额",
        dataIndex: 'beforeTransferOut',
    },
    {
        title: "转出后金额",
        dataIndex: 'afterTransferOut',
    },
    {
        title: "业务员",
        dataIndex: 'createUser',
    },
    {
        title: "转账日期",
        dataIndex: 'createTime',
    },
    {
        title: "备注",
        dataIndex: 'remarks',
    },
]
    const tabData = {
        "recharge": columns,
        "resizeLimit": resizeLimitHeader,
        "transferAccounts": transferAccountsHeader,
    }
    const tabList = {
        "recharge": SupplierRechargeList,
        "resizeLimit": SupplierResizeLimitList,
        "transferAccounts": SupplierTransferAccountsList,
    }
    useEffect(()=>{
        // console.log(tabsKey)
        if(props.name===tabsKey){
            // console.log(TabType,"挂载")
            // console.log(selectedSupplierBill)
            let params = {
                pageNum:1,
                pageSize:15,
                relationId:selectedSupplierBill.id
            }
            tabList[tabsKey]({showMsg: false, data: params})
        }
        // console.log(tabsList)
    },[tabsKey])
    const onPageChange=(page, pageSize)=>{
        // console.log(page, pageSize)
        const params = {...tabParams};
        params.pageNum = page;
        params.pageSize = pageSize;
        params.relationId= selectedSupplierBill.id
        // console.log(params)
        tabList[tabsKey]({showMsg: false, data: params})
        // loadCustomerList({showMsg: false, data: params});        
    }
    return (
        <>
            <TableHeader></TableHeader>
            <Table
                 bordered
                columns={tabData[tabsKey]}
                dataSource={tabsList}//这个是假json,后期通过数据返回列表数据
                pagination={{
                    defaultCurrent:1,
                    defaultPageSize:15,
                    onChange:onPageChange,
                    total:tabPage.total,
                    current:tabPage.pageNum                    
                }}
            />
        </>
    )
}